export const initialState = {
    contactUsList: [],
    activeContactUs:null
  };
